var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Notification Settings")]),(!_vm.settings)?_c('Loader'):_c('notification-settings-form',{attrs:{"on-save":_vm.onSave,"settings":_vm.settings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }